import { dashboardsPath } from 'adapter/in/common/routes';
import { useHistory, useRouteMatch } from 'react-router-dom';

export type Navigation = {
    navigationRoot: (from: string) => void;
    navigationPush: (where: string, from?: string) => void;
    navigationPushToContext: (where: string, from: string) => void;
    currentUrl: string;
};

export const useNavigation = (): Navigation => {
    const match = useRouteMatch();
    const history = useHistory();

    const navigationPush = (where: string, from = dashboardsPath) => {
        let url = match.url;
        const root = from ? `/${from}/` : '/';
        if (url.indexOf(root) === -1) {
            if (!url.endsWith('/')) {
                url += '/';
            }
            url += `${from}/`;
        }
        history.push(`${url.substring(0, url.indexOf(root))}${root}${where}`);
    };

    const navigationPushToContext = (where: string, from: string) => {
        const url = match.url;
        // Find the index where the keyword first appears in the URL
        const index = url.indexOf(from);

        // Extract the part of the URL from the keyword onwards
        const modifiedUrl = url.substring(0, index) + where;

        window.location.href = modifiedUrl;
    };

    return {
        navigationPush,
        navigationPushToContext,
        navigationRoot: (from: string) => navigationPush('', from),
        currentUrl: match.url,
    };
};
